/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AddConferenceUserRequest} from '../models/AddConferenceUserRequest';
import type {Conference} from '../models/Conference';
import type {CreateConferenceAccountRequest} from '../models/CreateConferenceAccountRequest';
import type {CreateConferenceAccountResponse} from '../models/CreateConferenceAccountResponse';
import type {CreateConferenceRequest} from '../models/CreateConferenceRequest';
import type {CreateConferenceResponse} from '../models/CreateConferenceResponse';
import type {Error} from '../models/Error';
import type {UpdateConferenceRequest} from '../models/UpdateConferenceRequest';

export interface AddConferenceUser$Request {
    accountId: number;
    addConferenceUserRequest: AddConferenceUserRequest;
}

export interface AddConferenceUser$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const addConferenceUserRequest = createAction<PayloadData<void, AddConferenceUser$Request>>('CONFERENCE__ADD_CONFERENCE_USER__REQUEST');
export const addConferenceUserSuccess = createAction<PayloadData<void, AddConferenceUser$Request>>('CONFERENCE__ADD_CONFERENCE_USER__SUCCESS');
export const addConferenceUserFailure = createAction<PayloadData<Error, AddConferenceUser$Request, true>>('CONFERENCE__ADD_CONFERENCE_USER__FAILURE');

export const addConferenceUserActions = [
    addConferenceUserRequest,
    addConferenceUserSuccess,
    addConferenceUserFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {AddConferenceUserRequest} meta.addConferenceUserRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const addConferenceUser = (meta: AddConferenceUser$Request, config?: AddConferenceUser$Config) => {
    return {
        CALL_API: {
            types: addConferenceUserActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/conferences/users`,
            TRANSPORT_REQUEST_BODY: meta.addConferenceUserRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface CreateConference$Request {
    accountId: number;
    createConferenceRequest?: CreateConferenceRequest;
}

export interface CreateConference$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const createConferenceRequest = createAction<PayloadData<void, CreateConference$Request>>('CONFERENCE__CREATE_CONFERENCE__REQUEST');
export const createConferenceSuccess = createAction<PayloadData<CreateConferenceResponse, CreateConference$Request>>('CONFERENCE__CREATE_CONFERENCE__SUCCESS');
export const createConferenceFailure = createAction<PayloadData<Error, CreateConference$Request, true>>('CONFERENCE__CREATE_CONFERENCE__FAILURE');

export const createConferenceActions = [
    createConferenceRequest,
    createConferenceSuccess,
    createConferenceFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {CreateConferenceRequest} [meta.createConferenceRequest]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const createConference = (meta: CreateConference$Request, config?: CreateConference$Config) => {
    return {
        CALL_API: {
            types: createConferenceActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/accounts/${meta.accountId}/conferences`,
            TRANSPORT_REQUEST_BODY: meta.createConferenceRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface CreateConferenceAccount$Request {
    createConferenceAccountRequest: CreateConferenceAccountRequest;
}

export interface CreateConferenceAccount$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const createConferenceAccountRequest = createAction<PayloadData<void, CreateConferenceAccount$Request>>('CONFERENCE__CREATE_CONFERENCE_ACCOUNT__REQUEST');
export const createConferenceAccountSuccess = createAction<PayloadData<CreateConferenceAccountResponse, CreateConferenceAccount$Request>>('CONFERENCE__CREATE_CONFERENCE_ACCOUNT__SUCCESS');
export const createConferenceAccountFailure = createAction<PayloadData<Error, CreateConferenceAccount$Request, true>>('CONFERENCE__CREATE_CONFERENCE_ACCOUNT__FAILURE');

export const createConferenceAccountActions = [
    createConferenceAccountRequest,
    createConferenceAccountSuccess,
    createConferenceAccountFailure
] as const;

/**
 * @param {CreateConferenceAccountRequest} meta.createConferenceAccountRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const createConferenceAccount = (meta: CreateConferenceAccount$Request, config?: CreateConferenceAccount$Config) => {
    return {
        CALL_API: {
            types: createConferenceAccountActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/accounts/conferences`,
            TRANSPORT_REQUEST_BODY: meta.createConferenceAccountRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAccountConference$Request {
    accountId: number;
}

export interface GetAccountConference$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountConferenceRequest = createAction<PayloadData<void, GetAccountConference$Request>>('CONFERENCE__GET_ACCOUNT_CONFERENCE__REQUEST');
export const getAccountConferenceSuccess = createAction<PayloadData<Conference, GetAccountConference$Request>>('CONFERENCE__GET_ACCOUNT_CONFERENCE__SUCCESS');
export const getAccountConferenceFailure = createAction<PayloadData<Error, GetAccountConference$Request, true>>('CONFERENCE__GET_ACCOUNT_CONFERENCE__FAILURE');

export const getAccountConferenceActions = [
    getAccountConferenceRequest,
    getAccountConferenceSuccess,
    getAccountConferenceFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountConference = (meta: GetAccountConference$Request, config?: GetAccountConference$Config) => {
    return {
        CALL_API: {
            types: getAccountConferenceActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/conferences`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetConferences$Request {
    requestBody: Array<number>;
}

export interface GetConferences$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getConferencesRequest = createAction<PayloadData<void, GetConferences$Request>>('CONFERENCE__GET_CONFERENCES__REQUEST');
export const getConferencesSuccess = createAction<PayloadData<{ [key: string]: Conference; }, GetConferences$Request>>('CONFERENCE__GET_CONFERENCES__SUCCESS');
export const getConferencesFailure = createAction<PayloadData<Error, GetConferences$Request, true>>('CONFERENCE__GET_CONFERENCES__FAILURE');

export const getConferencesActions = [
    getConferencesRequest,
    getConferencesSuccess,
    getConferencesFailure
] as const;

/**
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getConferences = (meta: GetConferences$Request, config?: GetConferences$Config) => {
    return {
        CALL_API: {
            types: getConferencesActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/conferences`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateConference$Request {
    accountId: number;
    conferenceId: number;
    updateConferenceRequest: UpdateConferenceRequest;
}

export interface UpdateConference$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateConferenceRequest = createAction<PayloadData<void, UpdateConference$Request>>('CONFERENCE__UPDATE_CONFERENCE__REQUEST');
export const updateConferenceSuccess = createAction<PayloadData<void, UpdateConference$Request>>('CONFERENCE__UPDATE_CONFERENCE__SUCCESS');
export const updateConferenceFailure = createAction<PayloadData<Error, UpdateConference$Request, true>>('CONFERENCE__UPDATE_CONFERENCE__FAILURE');

export const updateConferenceActions = [
    updateConferenceRequest,
    updateConferenceSuccess,
    updateConferenceFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {number} meta.conferenceId
 * @param {UpdateConferenceRequest} meta.updateConferenceRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateConference = (meta: UpdateConference$Request, config?: UpdateConference$Config) => {
    return {
        CALL_API: {
            types: updateConferenceActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/conferences/${meta.conferenceId}`,
            TRANSPORT_REQUEST_BODY: meta.updateConferenceRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

